const text = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M10.383 10.306H5.617l-1.07 2.969H3L7.344 1.9h1.312l4.352 11.375h-1.54zM6.07 9.072h3.867L8 3.752z"/></svg>',
};

export { text as default };
